import Modal from 'packs/helper/modal.js';
require("jquery")
require('bootstrap')
require("packs/slick")
import { dselect } from 'packs/dselect.js';

class LifeSessions {
	constructor() {
		document.addEventListener('turbo:load', this.init.bind(this));
	}

	loadModal() {
		const parnt = document.querySelector('#calendarDateContainer');
		const monthName = document.querySelector('.simple-calendarv2-month-name');
		const containers = [document.body, document.querySelector('.appContainer')];
		const modal = document.querySelector('.emodal');
		const modalHead = document.querySelector('.emodal-head');
		const modalBody = document.querySelector('.emodal-body');
		const closeModalBtn = document.querySelector('.emodal-close');

		// open modal
		parnt?.addEventListener('click', (e) => {
			const clicked = e.target.closest('.has-events');
			if (!clicked) return;

			containers.map((el) => el.classList.add('modalDisplayed'));
			modal.style.display = 'flex';
			modal.classList.add('emodal-active');
			modalBody.innerHTML = '';

			modalHead.innerHTML = monthName.innerHTML;

			Array.from(clicked.querySelectorAll('.calendar-txt-content')).map(
				(el) => {
					const date = el.querySelector('.calendar-session-date').textContent;
					const ttle = el.querySelector('.calendar-session-title').textContent;
					const link = el
						.querySelector('.calendar-session-title')
						.getAttribute('href');
					const markup = `<div class='modal-session-content'>
                          <p class='modal-session-content-date'>${date}</p>
                          <p><a href='${link}'>${ttle}</a></p>
                        </div>`;

					modalBody.insertAdjacentHTML('beforeend', `${markup}`);
				}
			);
		});

		const closeModal = function () {
			containers.map((el) => el.classList.remove('modalDisplayed'));
			modal.classList.remove('emodal-active');
			modal.style.display = 'none';
			modalBody.innerHTML = '';
			modalHead.innerHTML = '';
		};

		// close modal
		modal?.addEventListener('click', (e) => {
			if (!e.target.classList.contains('emodal-active')) return;
			closeModal();
		});

		closeModalBtn.addEventListener('click', closeModal);
	}

	popUpSpecialNotes() {
		const contentWrap = document.querySelector(
			'.detail2-content-special-notes'
		);
		const btn = document.querySelector('#specialNotesDisplay');
		btn?.addEventListener('click', (e) => {
			const content = e.target.closest('.detail2-content-special-notes').dataset
				.content;
			contentWrap.innerHTML = '';
			contentWrap.innerText = content;
		});
	}

  loadSliderImages() {
    const sliderElement = document.querySelectorAll('.sliderLazyElement');

    [...sliderElement].map(el => {
      const imgTag = document.createElement('img');
      imgTag.src = el.dataset.bg;

      imgTag.addEventListener('load', () => {
        imgTag.remove();
        el.classList.remove('welcome-slider-loader');
        el.style.backgroundImage = `url('${imgTag.src}')`;
      });
    });
  }

  artworkGallery() {
    $("#artworkSlider").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 2,
      slidesToScroll: 1,
      pauseOnFocus: false,
      pauseOnHover: false,
      prevArrow: $(".artworkArrwsPrev"),
      nextArrow: $(".artworkArrwsNext"),
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 1 }
        },
      ]
    });
  }

	initMainCalendarButtons() {
    $('.addNewSession').on('click', function(){
    	$('.howItWorksContainer').hide();
    })
    
    var url_string = window.location.href; //window.location.href
    var url = new URL(url_string);
    var c = url.searchParams.get("commit");
    
    if (c == "Search") {
      $( document ).ready(function() {
        console.log( "ready!" );
        $('#sessionsGrid').click();
      });
    }
	}

	timezone() {
		$('#timezone').change(function() {
	    $('#timezone_form').submit();
	  });
	}

  registerSessionPrice(){
    $('#session_register').input(function() {
      console.log("adsasdas");
    });
  }

	init() {
		// if (window.location.href.includes('session_id')) {
		//   Modal.init('open', document.querySelector('#displaySessionModal'));
		// }
		if ($('#stripe-closure').length > 0) {
			$('#stripe-closure').modal('show');
		}
		this.loadModal();
		this.popUpSpecialNotes();
    this.artworkGallery();
    this.loadSliderImages();
		this.initMainCalendarButtons();
		this.timezone();
    // this.registerSessionPrice();

		// var select_box_element = document.querySelector('#timezone');

		// dselect(select_box_element, {
		//     search: true
		// });
	}
}

new LifeSessions();

$(document).ready(function () {
	if ($('#stripe-closure').length > 0) {
		$('#stripe-closure').modal('show');
	}
})
